<template>
  <div class="error">
    <p>{{ error }}</p>
  </div>

  <div v-if="playlist" class="playlist-details">
    <!-- playlist information -->
    <div class="playlist-info">
      <div class="cover">
        <abbr
          title="Selected image for Playlist
        
        Click and zoom in"
        >
          <a :href="playlist.coverUrl" target="blank">
            <img :src="playlist.coverUrl" />
          </a>
        </abbr>
      </div>
      <div>
        <h2>Playlist name: {{ playlist.title }}</h2>
        <p class="username">Created by {{ playlist.userName }}</p>
        <p class="description">
          PLaylist description: {{ playlist.description }}
        </p>
        <button
          v-if="ownership"
          @click="handleDelete"
          class="btn playlistDelete topDelete"
          id="logOutBtn"
        >
          Delete playlist
        </button>
      </div>
    </div>

    <!-- song list -->
    <div class="song-list">
      <div v-if="!playlist.songs.length">
        No songs have been added to this playlist yet
      </div>
      <div class="scrollLit">
        <div class="single-song" v-for="song in playlist.songs" :key="song.id">
          <div class="details">
            <h3>{{ song.title }}</h3>
            <p>{{ song.artist }}</p>
          </div>
          <div class="audioController">
            <audio controls>
              <source :src="song.music" type="audio/ogg" />
              Your browser does not support the audio element.
            </audio>
            <button
              v-if="ownership"
              @click="songDelete(song.id)"
              id="logOutBtn"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
      <AddSongs v-if="ownership" :playlist="playlist" />
    </div>
    <!-- <button
      v-if="ownership"
      @click="handleDelete"
      class="btn playlistDelete bottomDelete"
      id="logOutBtn"
    >
      Delete playlist
    </button> -->
  </div>

  <div v-else class="spinners">
    <loading />
  </div>
</template>

<script>
import getDocument from "@/composable/getDocument";
import getUser from "@/composable/getUser";
import { computed } from "vue";
import useDocument from "@/composable/useDocument";
import useStorage from "@/composable/useStorage";
import { useRouter } from "vue-router";
import AddSongs from "@/components/AddSongs";

import loading from "@/components/loading.vue";

export default {
  props: ["id"],
  components: {
    AddSongs,
    loading,
  },
  setup(props) {
    const { error, document: playlist } = getDocument("playlist", props.id);
    const { deleteImage } = useStorage();
    const { deleteDoc, updateDoc } = useDocument("playlist", props.id);
    const router = useRouter();

    const { user } = getUser();
    const ownership = computed(() => {
      return (
        playlist.value && user.value && user.value.uid == playlist.value.userId
      );
    });

    const handleDelete = async () => {
      console.log(playlist.value.filePath);
      await deleteImage(playlist.value.filePath);
      await deleteDoc();
      router.push({ name: "home" });
    };

    const songDelete = async (id) => {
      console.log(id);
      let deletesong = null;
      playlist.value.songs = playlist.value.songs.filter(async (song) => {
        if (song.id == id) {
          await deleteImage(song.filePath);
        }
      });
      playlist.value.songs = playlist.value.songs.filter((song) => {
        return song.id !== id;
      });
      console.log(playlist.value.songs);

      await updateDoc({ songs: [...playlist.value.songs] });
    };

    return {
      ownership,
      playlist,
      error,
      handleDelete,
      songDelete,
    };
  },
};
</script>

<style>
.playlist-details {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 80px;
}
.cover {
  overflow: hidden;
  border-radius: 20px;
  position: relative;
  padding: 160px;
}
.cover img {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
  max-width: 200%;
  max-height: 200%;
}
.playlist-info {
  text-align: center;
}
.playlist-info h2 {
  text-transform: capitalize;
  font-size: 28px;
  margin-top: 20px;
}
.playlist-info p {
  margin-bottom: 20px;
}
.username {
  color: #999;
}
.description {
  text-align: left;
}

.single-song {
  padding: 10px 0;
  display: block;
  justify-content: space-between;
  align-items: center;
  /* border-bottom: 1px dashed var(--secondary); */
  border-bottom: 1px dashed cyan;
  margin-bottom: 20px;
}

/* main */

.scrollLit {
  max-height: calc(100vh - 260px);
  width: 100%;
  display: block;
  flex-direction: row;
  overflow-y: scroll;
}

.playlist-details {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 80px;
}

.audio {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

audio {
  width: 75%;
}

.audioController {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  /* width: 100%; */
}

.cover {
  overflow: hidden;
  border-radius: 20px;
  position: relative;
  padding: 160px;
}

.cover img {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
  max-width: 200%;
  max-height: 200%;
}

.playlist-info {
  text-align: center;
}

.playlist-info h2 {
  text-transform: capitalize;
  font-size: 28px;
  margin-top: 20px;
}

.playlist-info p {
  margin-bottom: 20px;
}

.username {
  color: #999;
}

.description {
  text-align: left;
}

.playlistDelete {
  padding: 5px 0px;
  width: 100%;
  top: 60px;
}

.topDelete {
  display: block;
}

.bottomDelete {
  display: none;
}

.audioController audio {
  width: 90%;
}

@media screen and (max-width: 1250px) {
  .audioController audio {
    width: 85%;
  }
}

@media screen and (max-width: 900px) {
  .audioController {
    display: block;
    text-align: center;
  }

  .audioController audio {
    display: block;
    width: 100%;
  }

  .audioController button {
    width: 90%;
    margin-top: 7px;
  }

  .playlist-details {
    display: block;
  }

  .playlist-info {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

@media screen and (max-width: 790px) {
  .audioController {
    display: block;
  }

  .audioController button {
    width: 100%;
  }

  .playlist-details {
    display: block;
  }

  .playlist-info {
    margin-bottom: 10px;
    display: block;
  }

  .btn {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  #firstSong {
    margin-top: 10px;
  }
  #addSongBtn {
    margin-bottom: 10px;
  }

  .song-list {
    margin: 10px 0px;
    border-top: 1px dashed black;
    border-bottom: 1px dashed black;
  }

  .topDelete {
    display: none;
  }

  .bottomDelete {
    display: block;
  }
}
</style>